module.exports = __webpack_public_path__ + "static/AvenirNext-DemiBold-f00d91f0391880828c9b346b4d298474.woff2";